import React from 'react';


export function LoadingScreen({screen}) {
  if (!screen) {
    return null
  } else {
    return (
      <div className="preloader-background" style={{display: 'flex'}}>
        <div className="preloader-wrapper big active">
          <div className="spinner-layer ">
            <div className="circle-clipper left">
              <div className="circle"></div>
            </div>
            <div className="gap-patch">
              <div className="circle"></div>
            </div>
            <div className="circle-clipper right">
              <div className="circle"></div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}